import React, { useEffect } from "react"
import type { ChakraProps } from "@chakra-ui/react"
import { Box } from "@chakra-ui/react"
import { useInView } from "react-intersection-observer"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import { addGTMEvent } from "utils/gtm"
import type { DataLayerEvent } from "utils/gtm/types"
import { useSegment } from "tracking"
import { useLandingPageContext } from "../LandingPageProvider"

type Props = CMSPageProps &
  ChakraProps & {
    children: React.ReactNode
    disabled?: boolean
  }

export const ElementViewEventWrapper: React.FC<Props> = ({
  children,
  trackingModule,
  disabled,
  ...props
}) => {
  const { pageId } = useLandingPageContext()
  const { track } = useSegment()
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0,
  })

  const { modulePosition, moduleContent, moduleId, locationType } =
    trackingModule
  const eventName = `${pageId}-elementView` as unknown as DataLayerEvent

  const moduleEvents = {
    module_position: modulePosition,
    module_content: moduleContent ?? "",
    module_id: moduleId,
    location_type: locationType,
  }

  useEffect(() => {
    if (inView && !disabled) {
      addGTMEvent({
        name: eventName,
        data: moduleEvents,
      })
      track({ event: "Page Element Viewed", properties: moduleEvents })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView])

  return (
    <Box ref={ref} w="full" {...props}>
      {children}
    </Box>
  )
}
